"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { ComboBox } from '../../ComboBox/ComboBox.mjs';
import { getValueSpecFromSchema } from '../../ComboBox/value-spec.mjs';
import { getFieldValueProps } from '../data-field.mjs';
import { useIsFieldFrozen } from '../hooks.mjs';
import useDataBuilder from '../use-data-builder.mjs';
import useDataBuilderField from '../use-data-builder-field.mjs';

function DefaultFieldValue({
  field,
  onChange,
  refsToIgnoreClick,
  topDropdownPanelComponent
}) {
  const { isEmpty, isRequired } = getFieldValueProps(field);
  const { isReadOnly } = useDataBuilder();
  const { autoOpen, setAutoOpen } = useDataBuilderField();
  const isFieldFrozen = useIsFieldFrozen();
  function handleDropdownClose() {
    setAutoOpen(false);
  }
  return /* @__PURE__ */ jsx(
    ComboBox,
    {
      value: isEmpty ? void 0 : field.value,
      schema: field.schema,
      onChange,
      valueSpec: getValueSpecFromSchema(field.schema),
      variablesSchema: field.variablesSchema,
      optionFactories: field.optionFactories,
      isRequired,
      disabled: isFieldFrozen || isReadOnly || !!field.schema?.readOnly,
      autoOpen,
      onClose: handleDropdownClose,
      refsToIgnoreClick,
      topDropdownPanelComponent
    }
  );
}

export { DefaultFieldValue as default };
